module.exports = __webpack_public_path__ + "media/src/ui/icons/upload-img-426140b242293ba12f02562cbb7656ae.png";